// pipe: 4B.7 (Task 13b) — the minimal portal nav layout. A token-styled header
// with links to the three authed portal screens, then an <Outlet/> for the
// screen body. 13c's Orders/Assets screens nest under this via the route table.
import { useI18n } from '@affine/i18n';
import { Link, Outlet } from 'react-router-dom';

import { usePortalAuth } from '../auth/portal-auth-provider';
import * as styles from './portal.css';

export function PortalLayout() {
  const t = useI18n();
  const { logout } = usePortalAuth();
  return (
    <div className={styles.layout}>
      <nav className={styles.nav}>
        <Link className={styles.navLink} to="/">
          {t['com.affine.pipe.portal.nav.impact']()}
        </Link>
        <Link className={styles.navLink} to="/orders">
          {t['com.affine.pipe.portal.nav.orders']()}
        </Link>
        <Link className={styles.navLink} to="/assets">
          {t['com.affine.pipe.portal.nav.assets']()}
        </Link>
        <Link className={styles.navLink} to="/certificates">
          {t['com.affine.pipe.portal.nav.certificates']()}
        </Link>
        <Link className={styles.navLink} to="/requests">
          {t['com.affine.pipe.portal.nav.requests']()}
        </Link>
        <span style={{ flex: 1 }} />
        <button
          type="button"
          className={styles.navLink}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          data-testid="portal-signout"
          onClick={logout}
        >
          {t['com.affine.pipe.portal.nav.signout']()}
        </button>
      </nav>
      <div className={styles.screen}>
        <Outlet />
      </div>
    </div>
  );
}
